import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardMedia,
  Button,
} from "@mui/material";
import SeoHelmet from "../../../Components/SeoHelmet";
import { useNavigate } from "react-router-dom";

const galleryData = [
  {
    id: 1,
    src: "/media/Gallery/pouriya-sabouri.webp",
    alt: "پوریا صبوری - Pouria Sabouri - Frontend Developer",
    title: "Pouria Sabouri",
  },
  {
    id: 100,
    src: "/media/Gallery/pouriya-sabouri-solo-yalda.jpg",
    alt: "پوریا صبوری - Pouria Sabouri - Frontend Developer",
    title: "Pouria Sabouri at yalda event",
  },
  {
    id: 2,
    src: "/media/Gallery/pouriya-sabouri-birth.jpg",
    alt: "پوریا صبوری - Pouria Sabouri - Frontend Developer",
    title: "Pouria Sabouri at birthday event at i3center",
  },
  {
    id: 3,
    src: "/media/Gallery/pouriya-sabouri-yalda.jpg",
    alt: "پوریا صبوری - Pouria Sabouri - Frontend Developer - i3center yalda",
    title: "Pouria Sabouri at yalda event with dev group",
  },
  {
    id: 4,
    src: "/media/Gallery/pouriya-sabouri-white.jpg",
    alt: "پوریا صبوری - Pouria Sabouri - Frontend Developer - amirreza sefidmoo",
    title: "Pouria Sabouri at yalda event",
  },
  {
    id: 5,
    src: "/media/Gallery/pouriya-sabouri-norooz.jpg",
    alt: "پوریا صبوری - Pouria Sabouri - Frontend Developer norooz",
    title: "Pouria Sabouri at yalda event",
  },
  {
    id: 6,
    src: "/media/Gallery/pouriya-sabouri-young.webp",
    alt: "پوریا صبوری - Pouria Sabouri - Frontend Developer - young pouri",
    title: "Pouria Sabouri",
  },
];

export default function Gallery() {
  const navigate = useNavigate();
  return (
    <Container maxWidth="xl" sx={{ py: 6 }}>
      <SeoHelmet
        title="گالری تصاویر پوریا صبوری | توسعه‌دهنده فرانت‌اند و ریکت"
        description="گالری تصاویر پوریا صبوری، توسعه‌دهنده فرانت‌اند و ریکت را مشاهده کنید. شامل عکس‌هایی از محیط کار، رویدادهای فناوری و پروژه‌های او."
        keywords="پوریا صبوری, توسعه‌دهنده فرانت‌اند, توسعه‌دهنده ریکت, گالری, نمونه کار, پوریا صبوری, برنامه‌نویس وب"
      />

      <Box sx={{ mb: 6, textAlign: "center" }}>
        <Typography
          variant="h3"
          component="h1"
          gutterBottom
          fontWeight="bold"
          color="primary"
        >
          Pouria Sabouri Gallery{" "}
          <span style={{ fontSize: ".8rem" }}>its just for seo !</span>
        </Typography>
        <Button onClick={() => navigate("/")}> go to homepage </Button>
        <Typography
          variant="body1"
          color="text.secondary"
          maxWidth="md"
          mx="auto"
          sx={{ lineHeight: 1.8 }}
        >
          Welcome to my gallery. Here you can find a collection of photos of me,{" "}
          <strong>Pouria Sabouri (پوریا صبوری)</strong>, working as a Frontend
          Developer. These images showcase my journey through various tech
          events, React/Next.js projects, and daily life in the tech industry.
        </Typography>
      </Box>

      {/* Gallery Grid */}
      <Grid container spacing={3}>
        {galleryData.map((item) => (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={item.id}>
            <Card
              sx={{
                borderRadius: 3,
                overflow: "hidden",
                boxShadow: 2,
                transition: "all 0.3s ease-in-out",
                cursor: "pointer",
                "&:hover": {
                  transform: "translateY(-8px) scale(1.02)",
                  boxShadow: 6,
                },
              }}
            >
              <CardMedia
                component="img"
                image={item.src}
                alt={item.alt}
                title={item.title}
                sx={{
                  height: 250,
                  objectFit: "cover",
                }}
              />
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
